import React from 'react';
import { TableRow, TableCell } from '@amzn/meridian/table';
import Tag from '@amzn/meridian/tag';
import type { TagType } from '@amzn/meridian/tag/tag';
import { PublisherDisplay } from 'src/components/common/PublisherDisplay';
import type { SpotlightJobHistoryItem } from 'src/store/spotlight-api';

const STATUS_TAG_TYPE_MAP: Record<string, TagType> = {
  SUCCESS: 'success',
  IN_PROGRESS: 'theme',
  FAILURE: 'error',
};

interface SpotlightJobHistoryRowProps {
  job: SpotlightJobHistoryItem;
}

export const SpotlightJobHistoryRow: React.FC<SpotlightJobHistoryRowProps> = ({ job }) => {
  return (
    <TableRow key={job.executionId}>
      <TableCell>{job.executionId}</TableCell>
      <TableCell><Tag type={STATUS_TAG_TYPE_MAP[job.status] ?? 'neutral'}>{job.status}</Tag></TableCell>
      <TableCell>{job.statusMessage}</TableCell>
      <TableCell>{job.outputSegmentName}</TableCell>
      <TableCell>{job.country}</TableCell>
      <TableCell>{job.partner && <PublisherDisplay publisher={job.partner} />}</TableCell>
      <TableCell>{job.seedSegmentId}</TableCell>
      <TableCell>{job.exclusionListSegmentId}</TableCell>
      <TableCell>{job.createdAt}</TableCell>
      <TableCell>{job.updatedAt}</TableCell>
      <TableCell>{job.accountIds?.join(', ')}</TableCell>
    </TableRow>
  );
};
